import { Literal, Static, Union } from '@sinclair/typebox';

export const LANGUAGE_CODES = {
  EN_AU: 'en-au',
  EN_BE: 'en-be',
  EN_CA: 'en-ca',
  FR_CA: 'fr-ca',
  DE_CH: 'de-ch',
  FR_CH: 'fr-ch',
  ZH_CH: 'zh-ch',
  ZH_CN: 'zh-cn',
  DE_DE: 'de-de',
  EN_DE: 'en-de',
  EN_CH: 'en-ch',
  DA_DK: 'da-dk',
  EN: 'en',
  ES_ES: 'es-es',
  EN_FI: 'en-fi',
  FR_FR: 'fr-fr',
  EN_GB: 'en-gb',
  EN_HK: 'en-hk',
  EN_IE: 'en-ie',
  EN_IT: 'en-it',
  JA_JP: 'ja-jp',
  EN_LU: 'en-lu',
  EN_NL: 'en-nl',
  NO_NO: 'no-no',
  NB_NO: 'nb-no',
  EN_PL: 'en-pl',
  EN_RU: 'en-ru',
  SV_SE: 'sv-se',
  EN_TH: 'en-th',
  EN_US: 'en-us',
  EN_KR: 'en-kr',
  KO_KR: 'ko-kr',
} as const;

export type LanguageCode = (typeof LANGUAGE_CODES)[keyof typeof LANGUAGE_CODES];

const codes = Object.values(LANGUAGE_CODES);

export type LanguageCodes = Static<typeof LanguageCodes>;
export const LanguageCodes = Union(
  codes.map(value => Literal(value)),
  {
    description: 'Language codes',
    examples: codes,
  }
);
